<script lang="ts">
  import { t } from '$lib/i18n/index.svelte';
  import { mediaBytes } from '$lib/media/fetch';
  import { defang } from '$lib/protocol/link-guard';
  import type { VideoElement } from '$lib/protocol/types';

  import type { ElementContext } from './context';

  let { element, ctx }: { element: VideoElement; ctx: ElementContext } = $props();

  let url = $state<string | undefined>(undefined);
  let loading = $state(false);
  let failed = $state(false);

  // Download-then-play: nothing streams at display time; the bytes come through
  // the signed media endpoint like every other file.
  async function load(): Promise<void> {
    loading = true;
    const media = await mediaBytes(ctx.accountId, element.mediaId);
    loading = false;
    if (media === undefined) {
      failed = true;
      return;
    }
    url = URL.createObjectURL(new Blob([media.bytes as BlobPart], { type: 'video/mp4' }));
  }
</script>

<div class="video">
  {#if url !== undefined}
    <!-- svelte-ignore a11y_media_has_caption — the protocol carries no caption tracks -->
    <video controls src={url}></video>
  {:else}
    <button onclick={() => void load()} disabled={loading}>
      {failed ? '⚠' : loading ? '…' : `▶ ${t('el.video.download')}`}
    </button>
  {/if}
  {#if element.caption !== undefined}
    <p class="caption">{defang(element.caption)}</p>
  {/if}
</div>

<style>
  video {
    max-width: 280px;
    width: 100%;
    border-radius: 10px;
  }
  button {
    border: 1px solid var(--line);
    background: var(--surface-2);
    color: var(--ink);
    border-radius: 10px;
    padding: 20px 24px;
    cursor: pointer;
  }
  .caption {
    font-size: 13px;
    color: var(--ink-soft);
    margin: 4px 0 0;
  }
</style>
